import React from 'react';
import {ContactView} from "../../../../types/Contact";
import {Card} from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export type ContactWidgetProps = {
	contact: ContactView;
}

export default function ContactWidget({contact}: ContactWidgetProps) {
	return <Card className="my-3">
		<Card.Header>
			<Card.Title>{contact.name}</Card.Title>
		</Card.Header>
		<Card.Body>
			{
				contact.items.map(
					(item, index) => <div key={index} className="border-bottom pb-1">
						<Row>
							<Col>{item.description}</Col>
						</Row>
						<Row>
							<Col md={4}>{item.name}</Col>
							<Col md={8}>{item.data}</Col>
						</Row>
					</div>
				)
			}
		</Card.Body>
	</Card>
}
